import { Grid, Theme, Typography } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import { observer } from "mobx-react";
import { useEffect } from "react";
import { useDocumentStore } from "@roc/feature-documents";
import { Alert, AlertTitle } from "@material-ui/lab";
import { formatCurrency } from "@roc/ui/utils";
import { isBlank, isNil } from "@roc/feature-utils";
import { CONFIRMED_VALUATION_STATUS, REFUNDED_VALUATION_STATUS, REJECTED_VALUATION_STATUS } from "../../../stores/documentForms/firstAppraisalValueConfirmation/firstAppraisalValueConfirmationStore";

const useStyles = makeStyles((theme: Theme) => ({
}));

export const FirstAppraisalValueConfirmation = observer(({ }) => {
  const classes = useStyles();

  const {
    documentStore: {
      documentFormStore: { firstAppraisalValueConfirmationStore },
    },
  } = useDocumentStore();

  useEffect(() => {
    firstAppraisalValueConfirmationStore.initialize();
  }, []);

  return (
    <Grid container spacing={1}>
      {firstAppraisalValueConfirmationStore?.confirmValuationStatus === CONFIRMED_VALUATION_STATUS &&
        <Grid item xs={12}>
          <Alert severity="success">
            <AlertTitle>Confirmed</AlertTitle>
            Valuation accepted by Origination
          </Alert>
        </Grid>
      }
      {(firstAppraisalValueConfirmationStore?.confirmValuationStatus === REJECTED_VALUATION_STATUS || firstAppraisalValueConfirmationStore?.confirmValuationStatus === REFUNDED_VALUATION_STATUS) &&
        <Grid item xs={12}>
          <Alert severity="error">
            <AlertTitle>Rejected</AlertTitle>
            Valuation rejected by Origination
          </Alert>
        </Grid>
      }
      {isBlank(firstAppraisalValueConfirmationStore?.confirmValuationStatus) &&
        <Grid item xs={12} container spacing={1}>
          <Grid item xs={12}>
            <Typography variant='body1'>
              Valuation from the First Appraisal Report is:
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant='body1'>
              {<b>{!isNil(firstAppraisalValueConfirmationStore?.appraisalValue1) ? formatCurrency(firstAppraisalValueConfirmationStore?.appraisalValue1) : '-'}</b>
              }
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant='body1'>
              Please click Confirm below to order secondary valuation
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant='body1'>
              Otherwise, please click Reject below to indicate your dissatisfaction with the first appraisal value
            </Typography>
          </Grid>
        </Grid>
      }
    </Grid>
  );
});